<template>
	<div class="forgot-container">
		<div class="forgot-content">
			<!-- Logo -->
			<div class="logo-wrapper">
				<img src="../assets/logo-sc-blanco.svg" alt="Logo" class="logo-img" />
			</div>

			<!-- Forgot Card -->
			<div class="forgot-card">
				<div class="card-icon">
					<v-icon size="32" color="#6200ea">mdi-email-outline</v-icon>
				</div>
				<h1 class="card-title">{{ $t('forgot.txtTitle') }}</h1>
				<p class="card-subtitle">{{ $t('forgot.txtSubtitle') || 'Ingresa tu correo para recuperar tu contraseña' }}</p>

				<v-form v-model="valid" ref="form" class="forgot-form">
					<!-- Email Input State -->
					<template v-if="!returnLogin">
						<div class="input-group">
							<label class="input-label">{{ $t('global.email') }}</label>
							<v-text-field
								v-model="email"
								:rules="emailRules"
								:placeholder="$t('forgot.emailPlaceholder') || 'tu@email.com'"
								required
								outlined
								dense
								hide-details="auto"
								autocomplete="email"
								class="modern-input"
								@keyup.enter="submit"
							></v-text-field>
						</div>

						<button
							type="button"
							class="submit-btn"
							:class="{ 'btn-disabled': !valid || disabled }"
							:disabled="!valid || disabled"
							@click="submit"
						>
							<v-progress-circular
								v-if="loading"
								indeterminate
								color="white"
								size="20"
								width="2"
								class="mr-2"
							></v-progress-circular>
							{{ $t('forgot.btnSendEmail') }}
						</button>
					</template>

					<!-- Success State -->
					<template v-else>
						<div class="success-message">
							<v-icon size="48" color="#4caf50" class="mb-3">mdi-check-circle-outline</v-icon>
							<p class="success-text">{{ $t('forgot.txtEmaildSend') }}</p>
						</div>

						<button
							type="button"
							class="submit-btn"
							@click="login"
						>
							<v-icon size="18" color="white" class="mr-2">mdi-arrow-left</v-icon>
							{{ $t('forgot.btnReturnToLogin') }}
						</button>
					</template>

					<button
						v-if="!returnLogin"
						type="button"
						class="back-btn"
						@click.prevent="login"
					>
						{{ $t('forgot.btnBackToLogin') || 'Volver al inicio de sesión' }}
					</button>
				</v-form>
			</div>
		</div>

		<!-- Snackbar -->
		<v-snackbar v-model="snackbar" color="#333" rounded="pill" timeout="3000">
			{{ text }}
			<template v-slot:action="{ attrs }">
				<v-btn text v-bind="attrs" @click="snackbar = false" small>
					{{ $t('global.snackbar.close') }}
				</v-btn>
			</template>
		</v-snackbar>
	</div>
</template>

<script>
export default {
	data() {
		return {
			valid: false,
			text: this.$t('forgot.txtEmaildSend'),
			snackbar: false,
			email: "",
			emailRules: [
				(v) => !!v || this.$t('global.rules.emailRequired'),
				(v) =>
					/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
					this.$t('global.rules.emailValid'),
			],
			loading: false,
			disabled: false,
			returnLogin: false,
		};
	},
	methods: {
		submit(e) {
			if (e) e.preventDefault();
			this.loading = true;
			this.disabled = true;
			this.$axios
				.post("/auth/reset-password", {
					email: this.email,
				})
				.then(() => {})
				.catch(() => {
					this.text = this.$t('forgot.txTunexpectedError');
				})
				.finally(() => {
					this.loading = false;
					this.snackbar = true;
					this.returnLogin = true;
				});
		},
		clear() {
			this.$refs.form.reset();
		},
		login() {
			this.$router.push({ name: "Login" });
		},
	},
};
</script>

<style scoped>
.forgot-container {
	min-height: 100vh;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
}

.forgot-content {
	width: 100%;
	max-width: 360px;
}

.logo-wrapper {
	text-align: center;
	margin-bottom: 28px;
}

.logo-img {
	max-width: 200px;
	height: auto;
}

.forgot-card {
	background: #fff;
	border-radius: 16px;
	padding: 28px 24px;
}

.card-icon {
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background: #ede7f6;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto 16px;
}

.card-title {
	font-size: 22px;
	font-weight: 600;
	color: #1a1a1a;
	margin: 0 0 4px;
	text-align: center;
}

.card-subtitle {
	font-size: 14px;
	color: #888;
	margin: 0 0 24px;
	text-align: center;
}

.forgot-form {
	display: flex;
	flex-direction: column;
}

.input-group {
	margin-bottom: 16px;
}

.input-label {
	display: block;
	font-size: 13px;
	font-weight: 500;
	color: #555;
	margin-bottom: 6px;
}

.modern-input >>> .v-input__slot {
	border-radius: 10px !important;
	min-height: 46px !important;
}

.modern-input >>> .v-text-field__slot input {
	font-size: 14px;
}

.submit-btn {
	width: 100%;
	padding: 14px;
	border: none;
	border-radius: 10px;
	background: #6200ea;
	color: #fff;
	font-size: 15px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 8px;
}

.submit-btn:active {
	transform: scale(0.98);
	background: #5000d0;
}

.btn-disabled {
	background: #ccc;
	cursor: not-allowed;
}

.btn-disabled:active {
	transform: none;
	background: #ccc;
}

.back-btn {
	width: 100%;
	padding: 12px;
	border: none;
	background: transparent;
	color: #6200ea;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.15s ease;
	margin-top: 8px;
}

.back-btn:active {
	opacity: 0.7;
}

.success-message {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px 0 24px;
}

.success-text {
	font-size: 14px;
	color: #666;
	text-align: center;
	margin: 0;
	line-height: 1.5;
}
</style>
